
import { defineComponent } from 'vue'
import LandingPage from '@/views/LandingPage.vue'

export default defineComponent({
  name: 'App',
  components: {
    LandingPage
  }
})

